import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Box = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 12 14"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M1 4L6 1L11 4M1 4V10L6 13M1 4L6 7M6 13L11 10V4M6 13V7M11 4L6 7" />
    </svg>
  ),
)
Box.displayName = 'Box'

export default Box
